import { cloneDeep } from 'lodash';
import Api from 'api/v2/Api';
import CollectionApi from 'api/v2/CollectionApi';
import axios from 'axios';

class IdentityProvidersApi extends CollectionApi {
  constructor() {
    super('/api/v2/identity-providers', {
      skip: 0,
      limit: 50,
    });
  }

  /**
   * @todo Handle /api/v2 responses which return the total count in the
   * X-Total-Count HTTP header.
   * @todo this is a temporary work around with the IdP endpoint
   * until expected payload can be formatted as expected
   */
  fetch(skip, limit, sort, searchTerm, cancelToken, filters = [], pageToken, skipToken) {
    const params = {
      ...cloneDeep(this.defaultParams),
      skip,
      limit,
      sort,
      pageToken,
      skipToken,
    };

    // If sortIgnoreCase is defined, remove the case sensitive sort parameter.
    if (params.sortIgnoreCase) {
      delete params.sort;
    }

    params.filter = this.setFilterTerm(params, filters, searchTerm);
    this.setSearchTerm(params, searchTerm);

    return new Promise((resolve, reject) => {
      const mesg = 'Could not get items!';

      this.initialize()
        .then(() => {
          axios
            .get(`${this.baseUrl}?${this.param(params)}`, {
              cancelToken,
            })
            .then((resp) => {
              const idpList = resp?.data?.identityProviders || [];
              resolve({
                results: idpList,
                totalCount: idpList.length,
              });
            })
            .catch((error) => {
              this.handleFetchError(reject, mesg, error);
            });
        })
        .catch((error) => {
          Api.handleError(reject, mesg, error);
        });
    });
  }

  update(item) {
    const mesg = 'Unable to update item!';
    const id = item.objectId;

    return this.initialize()
      .then(() => axios.put(`${this.baseUrl}/${id}`, item))
      .then((resp) => {
        if (resp?.data) return resp.data;

        return Error('No data in update response.');
      })
      .catch((error = Error(mesg)) => {
        if (error?.response?.data?.error) {
          throw Error(error.response.data.error);
        }

        const newError = Api.handleError(
          null,
          error.mesg || mesg,
          error,
        );

        throw (newError instanceof Error) ? newError : Error(mesg);
      });
  }
}

export default new IdentityProvidersApi();
